import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, FormControl, Col, Radio } from 'react-bootstrap';

class FormInput extends Component {
  static displayName = 'FormInput';

  // static propTypes = {
  //   error: PropTypes.bool,
  //   label: PropTypes.string,
  //   name: PropTypes.string.isRequired,
  //   success: PropTypes.bool,
  //   warning: PropTypes.bool
  // }

  render() {
    const {
      error,
      success,
      warning,
      controlId,
      labelSize,
      label,
      type,
      ...props
    } = this.props;

    if (error || warning || success) {
      props.hasFeedback = true;
      props.bsStyle = error
        ? 'error'
        : warning
        ? 'warning'
        : success
        ? 'success'
        : null;
    }

    if (type === 'radio') {
      return (
        <Radio className="col-sm-offset-3" {...props}>
          {label}
        </Radio>
      );
    } else {
      return (
        <FormGroup controlId={controlId}>
          <Col sm={labelSize}>{label}</Col>
          <Col sm={12 - labelSize}>
            <FormControl type={type} placeholder={label} {...props} />
          </Col>
        </FormGroup>
      );
    }
  }
}

export default FormInput;
